import React, { Component } from 'react';
//import TopHeader from '../topHeader/topHeader';
import PnrDetails from '../pnrDetail/pnrDetail';

class Edit_policy extends Component {
	constructor(props){
    	super(props);
      	this.state = {
      	};
   	}

  	render() {
    	return (
    		<div className='ep-container'>
    			<PnrDetails />
    		</div>
    	);
  	}
}

export default Edit_policy;


// WEBPACK FOOTER //
// ./src/components/edit_policy/edit_policy.js